// extracted by mini-css-extract-plugin
module.exports = {"tagsBlock":"Tags_tagsBlock__jZRDy","myBtn":"Tags_myBtn__ZOxuO","link":"Tags_link__1DP1T"};